module.exports = __webpack_public_path__ + "img/difficultyLevel_1_gray.815d71b5.svg";